// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-testid=DataTableDocuments][data-v-639acc80] tr:hover{cursor:pointer!important}", ""]);
// Exports
module.exports = exports;
